import React from 'react';
import './DonationPage.css';

import { PageTitle } from '../../../components';
import { Donation } from '../../../sections';



const DonationPage = () => {

  return (

    <div className='donation-page'>

      {/* Page Title */}
      <PageTitle title={'Donation'} page={'Donation'} />

      {/* Donation Form */}
      <Donation />

    </div>

  );

}

export default DonationPage;